import translate from 'helpers/translate'
import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
import useAuth from 'store/AuthContext'
import useConfig from 'store/ConfigProvider'
import { FooterSkeleton } from 'components/Skeletons'
import {
  FacebookIcon,
  InstagramIcon,
  YoutubeIcon,
} from '../../assets/socialIcons'

const Footer = props => {
  const { settings, footer, isLoaded } = useConfig()
  const { setLoginModalShow, auth } = useAuth()

  const handleMyProfileClick = e => {
    if (!auth) {
      e.preventDefault()
      setLoginModalShow(true)
    }
  }
  const handleMyOrdersClick = e => {
    if (!auth) {
      e.preventDefault()
      setLoginModalShow(true)
    }
  }

  if (!isLoaded || !footer || !Array.isArray(footer) || footer.length === 0) {
    return <FooterSkeleton />
  }

  return (
    <footer className="bg-[#111b27] text-white pt-12 md:pt-16 w-full px-2 md:px-0">
      <div className="mx-auto container">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 mb-10">
          <div className="footer-section">
            <h3 className="text-white text-base font-semibold mb-5 tracking-tight">
              კონტაქტი
            </h3>
            <div className="text-[#cccccc] text-sm leading-relaxed">
              <a
                href="tel:0322423500"
                className="text-white font-semibold text-base mb-2 block hover:underline w-fit"
              >
                032 2 80 02 02
              </a>

              <a
                href="mailto:info@crocoshop.ge"
                className="text-white font-medium block mb-4 hover:underline w-fit"
              >
                info@crocoshop.ge
              </a>

              <div className="my-4 py-3 border-t border-b border-white/10">
                <strong className="text-white text-[13px] font-semibold block mb-1.5">
                  {translate('workingHours')}
                </strong>
                <span className="text-[#cccccc] text-sm">
                  ორშ-კვი: 10:00-21:00
                </span>
              </div>

              <address className="not-italic text-[#cccccc] text-sm leading-relaxed">
                დიდუბის რაიონი, კოტე მარჯანიშვილის ქუჩა 26ა, 0112
                <br />
                თბილისი, საქართველო
              </address>

              <div className="flex gap-3 mt-5">
                {settings.facebook_url && (
                  <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href={settings.facebook_url}
                    className="w-9 h-9 bg-white/10 rounded-md flex items-center justify-center text-[#cccccc] hover:bg-white/20 hover:text-white transition-all duration-200"
                  >
                    <FacebookIcon />
                  </a>
                )}
                {settings.instagram_url && (
                  <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href={settings.instagram_url}
                    className="w-9 h-9 bg-white/10 rounded-md flex items-center justify-center text-[#cccccc] hover:bg-white/20 hover:text-white transition-all duration-200"
                  >
                    <InstagramIcon />
                  </a>
                )}
                {settings.youtube_url && (
                  <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href={settings.youtube_url}
                    className="w-9 h-9 bg-white/10 rounded-md flex items-center justify-center text-[#cccccc] hover:bg-white/20 hover:text-white transition-all duration-200"
                  >
                    <YoutubeIcon />
                  </a>
                )}
              </div>
            </div>
          </div>

          {(footer || [])
            .filter(footerSection => footerSection.title !== 'კონტაქტი')
            .map((footerSection, footer_key) => {
              if (
                !Array.isArray(footerSection.children) &&
                !footerSection.children.count
              )
                return null
              return (
                <div key={footerSection.id} className="footer-section">
                  <h3 className="text-white text-base font-semibold mb-5 tracking-tight">
                    {footerSection.title}
                  </h3>
                  <ul className="space-y-2.5">
                    {footer_key === 2 && (
                      <Fragment>
                        <li>
                          <Link
                            to="/account/orders"
                            onClick={handleMyProfileClick}
                            className="text-[#cccccc] text-sm leading-relaxed hover:text-white transition-colors duration-200"
                          >
                            ჩემი პროფილი
                          </Link>
                        </li>
                        <li>
                          <Link
                            onClick={handleMyOrdersClick}
                            to="/account/orders"
                            className="text-[#cccccc] text-sm leading-relaxed hover:text-white transition-colors duration-200"
                          >
                            ჩემი შეკვეთები
                          </Link>
                        </li>
                      </Fragment>
                    )}
                    {footerSection.children.map(child => {
                      return (
                        <li key={child.id}>
                          <Link
                            to={child.url || ''}
                            className="text-[#cccccc] text-sm leading-relaxed hover:text-white transition-colors duration-200"
                          >
                            {child.title || ''}
                          </Link>
                        </li>
                      )
                    })}
                  </ul>
                </div>
              )
            })}
        </div>
      </div>

      <div className="bg-[#0f1820] border-t border-white/10 py-5 text-center">
        <div className="max-w-7xl mx-auto px-5">
          <p className="text-[#999999] text-[13px] m-0">
            {translate('footerText')}
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
